import ApiService from './api.service';
import { parseAuditLogTimeline } from '../parsers/auditLog.parser';

const EligibilityService = {
  async checkEligibility(eligibilityData) {
    const url = `${window.ambulnzConfig.tenantedRestApiUrl}/EligibilityLookups`;
    const response = await ApiService.post(url, eligibilityData);

    return response.json();
  },
  async acceptEligibilityResult({ verificationId }) {
    const url = `${window.ambulnzConfig.tenantedRestApiUrl}/EligibilityLookups/accept`;
    const response = await ApiService.post(url, { verificationId });

    return response.json();
  },
  async checkMultiEligibility({ patient, coverages, tripDate, eligibilityMode, requestId, wandAttemptId }) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications`;

    return await ApiService.makeRequestSafe(url, {
      method: 'POST',
      body: { patient, coverages, tripDate, eligibilityMode, requestId, ...(wandAttemptId ? { wandAttemptId } : {}) },
    });
  },
  async acceptInsuranceVerification(verificationId) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications/${verificationId}/Accept`;

    return await ApiService.makeRequestSafe(url, { method: 'POST' });
  },
  async rejectInsuranceVerification(verificationId, rejectReason) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications/${verificationId}/Reject`;

    return await ApiService.makeRequestSafe(url, {
      method: 'POST',
      body: { rejectReason },
    });
  },
  async getLastInsuranceVerification(requestId) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications/Last?requestId=${requestId}`;
    return await ApiService.makeRequestSafe(url);
  },
  async getInsuranceVerificationRunStatus(requestId) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications/RunStatus?requestId=${requestId}`;
    return await ApiService.makeRequestSafe(url);
  },
  async getInsuranceVerification(verificationId) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications/${verificationId}`;
    return await ApiService.makeRequestSafe(url);
  },
  async insuranceVerifications(requestId) {
    const url = `${window.ambulnzConfig.tenantedRestApiV2Url}/InsuranceVerifications?requestId=${requestId}`;
    try {
      const response = await ApiService.makeRequestSafe(url);
      return parseAuditLogTimeline(response);
    } catch (e) {
      console.error('insuranceVerifications error:', e);
      throw e;
    }
  },
};

export default EligibilityService;
